import React from 'react';
import { ImageObj } from '../../../../types/ImageObj.types';
import Amenities from './Amenities';
import Location from './Location';
import DynamicTabs from '@components/DynamicTabs';
import WaldorfContainer from '@components-launch/WaldorfAstoriaLaunch/WaldorfContainer';
import cn from './style.module.scss';
interface SpecificationTabProps {
  specificationMobileTheme: {
    location: ImageObj[];
  };
  specificationDesktopTheme: {
    location: ImageObj[];
  };
  t: any;
}
export default function SpecificationTab(props: SpecificationTabProps) {
  const { t } = props;

  const tabs = [
    {
      title: t['beachHouseAmenitiesTab'] || 'Amenities',
      bgColor: '#272525',
      content: (
        <>
          <Amenities t={t} />
        </>
      ),
    },
    {
      title: t['beachHouseLocationTab'] || 'Location',
      bgColor: '#272525',
      content: (
        <>
          <Location
            t={t}
            tabImages={props.specificationDesktopTheme.location}
            mobTabImages={props.specificationMobileTheme.location}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <WaldorfContainer>
        <DynamicTabs
          tabs={tabs}
          showIndenter={true}
          className={cn.homeSpecificationTab}
          tabClass={cn.homeSpecificationElement}
          activeClassName={cn.homeSpecificationActive}
        />
      </WaldorfContainer>
    </>
  );
}
